import React, { useState, useEffect } from 'react';
import UserIcon from 'assets/icon/UserIcon';
import CategoryIcon from 'assets/icon/CategoryIcon';
import SettingIcon from 'assets/icon/SettingIcon';
import NotepadIcon from 'assets/icon/NotepadIcon';
import DashboardIcon from 'assets/icon/DashboardIcon';
import DoorOpenIcon from 'assets/icon/DoorOpenIcon';
import CreditCardIcon from 'assets/icon/CreditCardIcon';
import GroupIcon from 'assets/icon/GroupIcon';
import TableIcon from 'assets/icon/TableIcon';
import CalculatorIcon from 'assets/icon/CalculatorIcon';
import LineChartIcon from 'assets/icon/LineChartIcon';
import MoneyIcon from 'assets/icon/MoneyIcon';
import PinLocationIcon from 'assets/icon/PinLocationIcon';
import { SidebarMenuButton } from 'components/Button/SidebarMenuButton';

export default function Sidebar({ isOpen, onSidebarClick }) {
	const [isSidebarHome, setIsSidebarHome] = useState(true)
	const [isAdmin, setIsAdmin] = useState("0")
	let pathArray = window.location.pathname.split("/")

	const textSize = 'text-sm'
	const iconSize = 'w-5'
	
	useEffect(() => {
		setIsAdmin(localStorage.getItem("IsAdmin"))
		// setIsAdmin("1")
	}, [])

	useEffect(() => {
		if (pathArray[1] === "location"){
			setIsSidebarHome(false)
		}else{
			setIsSidebarHome(true)
		}
	}, [pathArray])
  
	return (
		<div className={`fixed sm:relative h-screen bg-white shadow-md transition-all z-20 ${ isOpen ? 'w-64' : 'hidden sm:block sm:w-20' } `}>
			<div className={`h-screen flex flex-col items-center gap-6 lg:text-base w-full`}>
				<div className="items-start flex flex-col w-full gap-2 px-4 py-4 overflow-y-auto mb-14">
					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={true}
						title='Dashboard'
						href="/"
					>
						<DashboardIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>
					
					<div className={`mt-4 text-sm ${ isOpen ? 'block' : 'hidden h-20' }`}>
						<span>Menu</span>
					</div>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={true}
						title='Room'
						href="/rooms"
					>
						<DoorOpenIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={true}
						title='Booking'
						href="/booking"
					>
						<DoorOpenIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={true}
						title='Tenant'
						href="/tenant"
					>
						<DoorOpenIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<div className={`mt-4 text-sm ${ isOpen ? 'block' : 'hidden' }`}>
						<span>Cashflow</span>
					</div>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={true}
						title='Payment'
						href="/payment"
					>
						<MoneyIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>
					
					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={true}
						title='Deposit'
						href="/deposit"
					>
						<MoneyIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={true}
						title='Expense'
						href="/expense"
					>
						<CreditCardIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<div className={`mt-4 text-sm ${ isOpen ? 'block' : 'hidden' }`}>
						<span>Report</span>
					</div>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={true}
						title='Reports'
						href="/reports"
					>
						<CreditCardIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>

					<div className={`mt-4 text-sm ${ isOpen ? 'block' : 'hidden' }`}>
						<span>Human Resource</span>
					</div>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={isAdmin}
						title='Employee'
						href="/employee"
					>
						<UserIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>
					
					<div className={`mt-4 text-sm ${ isOpen ? 'block' : 'hidden' }`}>
						<span>Setting</span>
					</div>

					<SidebarMenuButton 
						onClick={onSidebarClick}
						isOpen={isOpen}
						visible={isAdmin}
						title='Setting'
						href="/setting"
					>
						<SettingIcon className={`fill-black ${iconSize}`} />
					</SidebarMenuButton>
				</div>
			</div>
			{ isSidebarHome ?
				// Home Sidebar
				// <div className={`h-screen flex flex-col items-center gap-6 md:text-xs lg:text-base py-4 w-full`}>
				// 	{/* <div className={`flex w-full items-center px-4 ${ isOpen ? 'flex-row' : 'flex-row justify-center' } `}>
				// 		{ isOpen ? 
				// 				<a className="flex w-full px-4 gap-4" href="/" onClick={onSidebarClick}>
				// 					<h1 className={`my-auto font-bold italic `}>Admin</h1>
				// 				</a>
				// 			:
				// 				<a className="flex w-full px-4 gap-4 justify-center text-2xl" href="/" onClick={onSidebarClick}>
				// 					<h1 className={`my-auto font-bold italic `}>A</h1>
				// 				</a>
				// 		}
				// 	</div> */}
				// 	<div className="items-start flex flex-col w-full gap-2 px-4 overflow-y-auto">
				// 		<a className={`w-full py-3 px-4 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
				// 				${ window.location.pathname === '/' ? 'bg-slate-300' : '' } 
				// 				${ isOpen ? '' : 'justify-center' } 
				// 			`}
				// 			onClick={onSidebarClick}
				// 			href="/"
				// 		>
				// 			<DashboardIcon className='fill-black w-6' />
				// 			<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Home</p>
				// 		</a>

				// 		<a className={`w-full py-3 px-4 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
				// 				${ window.location.pathname === '/location' ? 'bg-slate-300' : '' }
				// 				${ isOpen ? '' : 'justify-center' }
				// 			`}
				// 			onClick={onSidebarClick}
				// 			href="/location-setting"
				// 		>
				// 			<CategoryIcon className='fill-black w-6' />
				// 			<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Location</p>
				// 		</a>
				// 		{/* <a className={`w-full py-3 px-4 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
				// 				${ window.location.pathname === '/location' ? 'bg-slate-300' : '' }
				// 				${ isOpen ? '' : 'justify-center' }
				// 			`}
				// 			onClick={onSidebarClick}
				// 			href="/setting"
				// 		>
				// 			<CategoryIcon className='fill-black w-6' />
				// 			<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Setting</p>
				// 		</a> */}
				// 		<a
				// 			className={`w-full py-3 px-4 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
				// 				${ window.location.pathname === '/user' ? 'bg-slate-300' : '' } 
				// 				${ isOpen ? '' : 'justify-center' }
				// 				${ isAdmin === "1" ? 'block' : 'hidden' }
				// 			`}
				// 			onClick={onSidebarClick}
				// 			href="/user"
				// 		>
				// 			<UserIcon className='fill-black w-6' />
				// 			<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>User</p>
				// 		</a>
				// 		<a
				// 			className={`w-full py-3 px-4 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
				// 				${ window.location.pathname === '/setting' ? 'bg-slate-300' : '' } 
				// 				${ isOpen ? '' : 'justify-center' }
				// 				${ isAdmin === "1" ? 'block' : 'hidden' }
				// 			`}
				// 			onClick={onSidebarClick}
				// 			href="/setting"
				// 		>
				// 			<SettingIcon className='fill-black w-6' />
				// 			<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Setting</p>
				// 		</a>
				// 	</div>
				// </div>	
				<div></div>
				:
				// Location Sidebar
				// <div className={`h-screen flex flex-col items-center gap-6 md:text-xs lg:text-base py-4 w-full`}>
				// 	{/* <div className={`flex w-full items-center px-4 ${ isOpen ? 'flex-row' : 'flex-row justify-center' } `}>
				// 		{ isOpen ? 
				// 				<a className="flex w-full px-4 gap-4" href="/" onClick={onSidebarClick}>
				// 					<h1 className={`my-auto font-bold italic `}>{ localStorage.getItem("KostName") }</h1>
				// 				</a>
				// 			:
				// 				<a className="flex w-full px-4 gap-4 justify-center" href="/" onClick={onSidebarClick}>
				// 					<h1 className={`my-auto font-bold italic text-2xl`}>{ Array.from(localStorage.getItem("KostName"))[0]  }</h1>
				// 				</a>
				// 		}
				// 	</div> */}

				// 	<div className="items-start flex flex-col w-full gap-2 px-4 overflow-y-auto">
				// 		<a className={`w-full py-3 px-4 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
				// 				${ window.location.pathname === '/location/transaction' ? 'bg-slate-300' : '' } 
				// 				${ isOpen ? '' : 'justify-center' } 
				// 			`}
				// 			onClick={onSidebarClick}
				// 			href="/location/transaction"
				// 		>
				// 			<DashboardIcon className='fill-black w-6' />
				// 			<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Transaksi</p>
				// 		</a>

				// 		<a className={`w-full py-3 px-4 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
				// 				${ window.location.pathname === '/kost/tenant' ? 'bg-slate-300' : '' }
				// 				${ isOpen ? '' : 'justify-center' }
				// 			`}
				// 			onClick={onSidebarClick}
				// 			href="/location/customer"
				// 		>
				// 			<GroupIcon className='fill-black w-6' />
				// 			<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Pelanggan</p>
				// 		</a>

				// 		<a className={`w-full py-3 px-4 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
				// 				${ window.location.pathname === '/location/customer-card' ? 'bg-slate-300' : '' }
				// 				${ isOpen ? '' : 'justify-center' }
				// 			`}
				// 			onClick={onSidebarClick}
				// 			href="/location/customer-card"
				// 		>
				// 			<DoorOpenIcon className='fill-black w-6' />
				// 			<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Kartu Pelanggan</p>
				// 		</a>

				// 		<a
				// 			className={`w-full py-3 px-4 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
				// 				${ window.location.pathname === '/kost/booking' ? 'bg-slate-300' : '' } 
				// 				${ isOpen ? '' : 'justify-center' }\
				// 			`}
				// 			onClick={onSidebarClick}
				// 			href="/kost/booking"
				// 		>
				// 			<NotepadIcon className='fill-black w-6' />
				// 			<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Booking</p>
				// 		</a>

				// 		<a
				// 			className={`w-full py-3 px-4 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
				// 				${ window.location.pathname === '/kost/payment' ? 'bg-slate-300' : '' } 
				// 				${ isOpen ? '' : 'justify-center' }
				// 			`}
				// 			onClick={onSidebarClick}
				// 			href="/kost/payment"
				// 		>
				// 			<CreditCardIcon className='fill-black w-6' />
				// 			<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Payment</p>
				// 		</a>

				// 		<a
				// 			className={`w-full py-3 px-4 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
				// 				${ window.location.pathname === '/kost/expense' ? 'bg-slate-300' : '' } 
				// 				${ isOpen ? '' : 'justify-center' }
				// 			`}
				// 			onClick={onSidebarClick}
				// 			href="/kost/expense"
				// 		>
				// 			<CreditCardIcon className='fill-black w-6' />
				// 			<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Kost Expense</p>
				// 		</a>

				// 		<a
				// 			className={`w-full py-3 px-4 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
				// 				${ window.location.pathname === '/kost/cashflow' ? 'bg-slate-300' : '' } 
				// 				${ isOpen ? '' : 'justify-center' }
				// 			`}
				// 			onClick={onSidebarClick}
				// 			href="/kost/cashflow"
				// 		>
				// 			<CreditCardIcon className='fill-black w-6' />
				// 			<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Cashflow</p>
				// 		</a>
						
				// 		<a
				// 			className={`w-full py-3 px-4 cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
				// 				${ window.location.pathname === '/kost/setting' ? 'bg-slate-300' : '' } 
				// 				${ isOpen ? '' : 'justify-center' }
				// 			`}
				// 			onClick={onSidebarClick}
				// 			href="/kost/setting"
				// 		>
				// 			<SettingIcon className='fill-black w-6' />
				// 			<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Setting</p>
				// 		</a>
				// 	</div>
				// </div>
				<div></div>
			}
		</div>
  	)
}
